//import TradeFixDataFunc from "@/pcomponents/common/content/trade/trade_fix/func/data_func";
import strFunc from '@/lib/lyg/string';

class TradeFixDataFunc {
  static default_info_data = {
    a_seq:"",
    a_day_num:"1",
    a_subject_code:"101",
    a_subject_name:"현금",
    a_subject_detail:"기타",
    a_trade_memo:"",
    a_cust_par_id:"trade_cust",
    a_cust_par_seq:"",
    a_cust_name:"",
    a_money:"",
    a_money_type:"money",
    a_inout:"out",
    a_pay_sort:"money",
    a_is_fix:"1",
    a_fix_term:"month",
  };
}
export default TradeFixDataFunc;